//  Waiting for the DOM model to load all components, then start
window.addEventListener('DOMContentLoaded', function () {
  'use strict'

  // Setting the function content
  function simpleTabs (tabHeadingList, tabHeading, tabText) {
    //  Putting into variables the Tab Heading List, Tab Headings as an array and Tab Content as an array
    const info = document.querySelector('.' + tabHeadingList)
    const tab = document.querySelectorAll('.' + tabHeading)
    const tabContent = document.querySelectorAll('.' + tabText)
    if (tab.length > 0) {
      tab[0].classList.add('active')

      // Function for HIDING the Tab Content, has argument 'a' which sets the number of content sections to be hidden
      function hideTabContent (a) {
        for (let i = a; i < tabContent.length; i++) {
          tabContent[i].classList.remove('show')
          tabContent[i].classList.add('hide')
        }
      }

      // Launching the hiding function
      hideTabContent(1)

      // Function for SHOWING the Tab Content which has number set in argument 'b'
      function showTabContent (b) {
        if (tabContent[b].classList.contains('hide')) {
          tabContent[b].classList.remove('hide')
          tabContent[b].classList.add('show')
        }
      }

      info.addEventListener('click', function (event) {
        Array.from(document.querySelectorAll('.info-header-tab.active')).forEach((el) => el.classList.remove('active'))
        event.target.classList.toggle('active')

        const target = event.target
        if (target && target.classList.contains(tabHeading)) {
          for (let i = 0; i < tab.length; i++) {
            if (target === tab[i]) {
              hideTabContent(0)
              showTabContent(i)
              break
            }
          }
        }
      })
    }
  }
  simpleTabs('info-header', 'info-header-tab', 'info-tabcontent')
})

const accordionBtns = document.querySelectorAll('.accordion')
accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle('is-open')
    this.classList.remove('activePanel')
    const content = this.nextElementSibling
    if (content.style.maxHeight) {
      content.style.maxHeight = null
    } else {
      content.style.maxHeight = content.scrollHeight + 'px'
    }
    const parent = this.parentElement.parentElement.parentElement
    if (parent && parent.classList.contains('medacMoleculeAccordionitem-content')) {
      window.setTimeout(() => {
        parent.style.maxHeight = parent.scrollHeight + 'px'
      }, 300)
    }
  }
  const activePanels = document.querySelectorAll('.activePanel')
  activePanels.forEach((activePanel) => {
    activePanel.classList.add('is-open')
    const content = activePanel.nextElementSibling
    content.style.maxHeight = content.scrollHeight + 'px'
  })
})
